import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ProductCard from '../ProductCard';
import { useCart } from '../../hooks/useCart';

interface CartRecomendationsProps {
  dataSet: {
    productId: number;
    baseUrl: string;
    limit: number;
    title: string;
    blurb: string;
  };
}

const CartRecommendations = (props: CartRecomendationsProps): JSX.Element => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const { cart } = useCart();
  const {
    dataSet: { baseUrl, productId, limit, title, blurb },
  } = props;
  const upsellProducts = window['theme'].cart_upsells;

  useEffect(() => {
    // Get more upsells if we don't have enough
    if (upsellProducts.length < limit) {
      axios.get(`${baseUrl}.json?product_id=${productId}&limit=${2 * limit}`)
        .then((res) => {
          const d = res.data;
          if (d && d.products) {
            const filteredProduct = d.products.filter(p => p.tags.indexOf('subscription-bundle') === -1 && p.type.toLowerCase() !== 'hidden' && p.type.toLowerCase() !== 'custom bundle').slice(0, limit)
            setProducts(filteredProduct);
            setLoading(false);
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      setLoading(false);
    }
  }, [setProducts, upsellProducts]);

  if (loading) {
    return <p className="loading-widget">loading....</p>;
  }

  let allProducts: any[] = upsellProducts.concat(products);

  // Ensure we don't show items already in the basket
  if (cart && cart.items) {
    const cartItemProductIds = cart.items.map((item) => item.product_id);
    allProducts = allProducts.filter((product) => cartItemProductIds.indexOf(product.id) === -1);
  }

  // Ensure we don't go over the limit
  allProducts = allProducts.splice(0, limit);

  return allProducts && allProducts.length > 0 ? (
    <section className="cart-recommendations-snippet">
      <header>
        <h2 className="text-upper">{title}</h2>
        <p className="sub-text">{blurb}</p>
      </header>
      <ul className="cl-product-card-container grid-list">
        {allProducts.map((product, i) => (
          <li className="grid-item" key={`product-recommendation-${i}`}>
            <div className="cl-product-card no-zoom">
              <ProductCard product={product} withDescription={true} canAddToCart={true} />
            </div>
          </li>
        ))}
      </ul>
    </section>
  ) : null;
};

export default CartRecommendations;
